import gql from 'graphql-tag'

export default gql`
mutation createBatchTrackingFlash($labelIds: [String!]) {
  createBatchTrackingFlash(labelIds: $labelIds) {
    _id
    sendHook
  }
}
`


// WEBPACK FOOTER //
// ./src/graphql/mutations/CreateBatchTrackingFlash.js